/** ISO 3166-1 alpha-2 codes for the Zone product badge (country flag). */
export const ZONE_COUNTRY_OPTIONS = [
  { code: "tn", name: { en: "Tunisia", fr: "Tunisie" } },
  { code: "fr", name: { en: "France", fr: "France" } },
  { code: "it", name: { en: "Italy", fr: "Italie" } },
  { code: "es", name: { en: "Spain", fr: "Espagne" } },
  { code: "ma", name: { en: "Morocco", fr: "Maroc" } },
  { code: "dz", name: { en: "Algeria", fr: "Algérie" } },
  { code: "lb", name: { en: "Lebanon", fr: "Liban" } },
  { code: "tr", name: { en: "Turkey", fr: "Turquie" } },
  { code: "gr", name: { en: "Greece", fr: "Grèce" } },
  { code: "pt", name: { en: "Portugal", fr: "Portugal" } },
  { code: "eg", name: { en: "Egypt", fr: "Égypte" } },
  { code: "sy", name: { en: "Syria", fr: "Syrie" } },
  { code: "hr", name: { en: "Croatia", fr: "Croatie" } },
  { code: "cy", name: { en: "Cyprus", fr: "Chypre" } },
  { code: "mt", name: { en: "Malta", fr: "Malte" } },
  { code: "de", name: { en: "Germany", fr: "Allemagne" } },
  { code: "be", name: { en: "Belgium", fr: "Belgique" } },
  { code: "nl", name: { en: "Netherlands", fr: "Pays-Bas" } },
  { code: "ch", name: { en: "Switzerland", fr: "Suisse" } },
  { code: "at", name: { en: "Austria", fr: "Autriche" } },
  { code: "gb", name: { en: "United Kingdom", fr: "Royaume-Uni" } },
  { code: "us", name: { en: "United States", fr: "États-Unis" } },
  { code: "ca", name: { en: "Canada", fr: "Canada" } },
  { code: "mx", name: { en: "Mexico", fr: "Mexique" } },
  { code: "br", name: { en: "Brazil", fr: "Brésil" } },
  { code: "ar", name: { en: "Argentina", fr: "Argentine" } },
  { code: "jp", name: { en: "Japan", fr: "Japon" } },
  { code: "cn", name: { en: "China", fr: "Chine" } },
  { code: "kr", name: { en: "South Korea", fr: "Corée du Sud" } },
  { code: "in", name: { en: "India", fr: "Inde" } },
  { code: "sa", name: { en: "Saudi Arabia", fr: "Arabie saoudite" } },
  { code: "ae", name: { en: "UAE", fr: "Émirats" } },
  { code: "qa", name: { en: "Qatar", fr: "Qatar" } },
  { code: "sn", name: { en: "Senegal", fr: "Sénégal" } },
  { code: "ci", name: { en: "Ivory Coast", fr: "Côte d'Ivoire" } },
  { code: "ng", name: { en: "Nigeria", fr: "Nigeria" } },
  { code: "gh", name: { en: "Ghana", fr: "Ghana" } },
  { code: "et", name: { en: "Ethiopia", fr: "Éthiopie" } },
  { code: "ke", name: { en: "Kenya", fr: "Kenya" } },
  { code: "tz", name: { en: "Tanzania", fr: "Tanzanie" } },
  { code: "za", name: { en: "South Africa", fr: "Afrique du Sud" } },
  { code: "na", name: { en: "Namibia", fr: "Namibie" } },
  { code: "jo", name: { en: "Jordan", fr: "Jordanie" } },
  { code: "ps", name: { en: "Palestine", fr: "Palestine" } },
  { code: "pk", name: { en: "Pakistan", fr: "Pakistan" } },
  { code: "bd", name: { en: "Bangladesh", fr: "Bangladesh" } },
  { code: "lk", name: { en: "Sri Lanka", fr: "Sri Lanka" } },
  { code: "th", name: { en: "Thailand", fr: "Thaïlande" } },
  { code: "vn", name: { en: "Vietnam", fr: "Vietnam" } },
  { code: "my", name: { en: "Malaysia", fr: "Malaisie" } },
  { code: "id", name: { en: "Indonesia", fr: "Indonésie" } },
  { code: "jm", name: { en: "Jamaica", fr: "Jamaïque" } },
  { code: "cu", name: { en: "Cuba", fr: "Cuba" } },
  { code: "do", name: { en: "Dominican Republic", fr: "République dominicaine" } },
  { code: "fj", name: { en: "Fiji", fr: "Fidji" } },
  { code: "ws", name: { en: "Samoa", fr: "Samoa" } },
  { code: "pf", name: { en: "Tahiti", fr: "Tahiti" } },
  { code: "pe", name: { en: "Peru", fr: "Pérou" } },
  { code: "se", name: { en: "Sweden", fr: "Suède" } },
  { code: "no", name: { en: "Norway", fr: "Norvège" } },
  { code: "dk", name: { en: "Denmark", fr: "Danemark" } },
  { code: "fi", name: { en: "Finland", fr: "Finlande" } },
  { code: "pl", name: { en: "Poland", fr: "Pologne" } },
  { code: "hu", name: { en: "Hungary", fr: "Hongrie" } },
  { code: "cz", name: { en: "Czech Republic", fr: "République tchèque" } },
  { code: "ua", name: { en: "Ukraine", fr: "Ukraine" } },
  { code: "ro", name: { en: "Romania", fr: "Roumanie" } },
];

export function getZoneCountryFlagUrl(code) {
  const normalized = String(code || "").trim().toLowerCase();
  if (!normalized) return "";
  return `https://flagcdn.com/w40/${normalized}.png`;
}

export function getZoneCountryOption(code) {
  const normalized = String(code || "").trim().toLowerCase();
  return ZONE_COUNTRY_OPTIONS.find((item) => item.code === normalized) || null;
}

export function getZoneCountryLabel(code, language = "en") {
  const option = getZoneCountryOption(code);
  if (!option) return String(code || "").toUpperCase();
  return option.name[language] || option.name.en;
}

export function isValidZoneCountryCode(code) {
  return Boolean(getZoneCountryOption(code));
}
